import BaseApi from './BaseApi';

export const COURSES_ENDPOINTS = {
  GET_FULL_COURSE_RESOURCE: '/api/viewFullCourseResourceJson',
  GET_HIDDEN_COURSE_RESOURCE_IDS: '/api/getHiddenCourseResourceElementIds'
};

export class CoursesApi extends BaseApi {
  async getFullCourseResource(courseContentItemId) {
    const url = this.getUrl(COURSES_ENDPOINTS.GET_FULL_COURSE_RESOURCE, { courseContentItemId });
    const response = await this.fetch(url, { withoutCheck: true });
    const fullCourseResource = !!response && JSON.parse(response.jsonString);

    // Default to friendly course name if it exists, otherwise fall back to original name.
    // Replace ROOT name with courseContentItemFriendlyName at fetch level to avoid modifying complex nested JSON.
    // Preserve original name as originalName for future reference.
    if (fullCourseResource) {
      const originalName = fullCourseResource.name;
      fullCourseResource.originalName = originalName;
      fullCourseResource.name = response.courseContentItemFriendlyName || originalName;
    }

    return fullCourseResource;
  }

  async getHiddenCourseResourceIds(classroomId, courseContentItemId) {
    const url = this.getUrl(COURSES_ENDPOINTS.GET_HIDDEN_COURSE_RESOURCE_IDS, { classroomId, courseContentItemId });
    const response = await this.fetch(url);
    return response.courseResourceElementIds;
  }
}

export default new CoursesApi();
